import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetSaleRequestQueryResponse, GetSaleRequestPathParams, GetSaleRequest400, GetSaleRequest404, GetSaleRequest500 } from "../types/GetSaleRequest";

export const getSaleRequestQueryKey = (requestId: GetSaleRequestPathParams["requestId"]) =>     [{url:`/api/salerequests/${requestId}`,params:{requestId:requestId}}] as const;
      export function getSaleRequestQueryOptions <TData = GetSaleRequestQueryResponse, TError = GetSaleRequest400 | GetSaleRequest404 | GetSaleRequest500>(requestId: GetSaleRequestPathParams["requestId"], options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getSaleRequestQueryKey(requestId, );

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/salerequests/${requestId}`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение заявки пользователя
 * @link /api/salerequests/:requestId
 */

export function useGetSaleRequest <TData = GetSaleRequestQueryResponse, TError = GetSaleRequest400 | GetSaleRequest404 | GetSaleRequest500>(requestId: GetSaleRequestPathParams["requestId"], options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getSaleRequestQueryKey(requestId, );

  const query = useQuery<TData, TError>({
    ...getSaleRequestQueryOptions<TData, TError>(requestId, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
